import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { twMerge } from 'tailwind-merge';
import {
  LILI_PRIVACY_POLICY_URL,
  LILI_TERMS_OF_USE_URL,
  SUNRISE_ACCOUNT_MANAGMENT_AGREEMENT_URL,
} from '@Types/consts.ts';
interface TermsAndConditionsProps {
  onTncClick: () => void;
  onPrivacyPolicyClick: () => void;
  isEmbedded?: boolean;
}
export const TermsAndConditions = ({
  onTncClick,
  onPrivacyPolicyClick,
  isEmbedded = false,
}: TermsAndConditionsProps) => {
  const { t } = useTranslation();

  return (
    <span className={isEmbedded ? 'sm:max-w-[248px]' : ''}>
      <Text.H12 className={twMerge('text-center text-text-main-tertiary w-full')}>
        {t('pages.home.byClicking')}
        <a
          className='underline text-text-main-tertiary'
          href={LILI_TERMS_OF_USE_URL}
          target='_blank'
          id='terms-of-us'
          onClick={(e) => {
            e.stopPropagation();
            onTncClick();
          }}
          rel='noreferrer'>
          {t('pages.home.terms')}
        </a>
        {', '}
        {!isEmbedded && (
          <a
            className='underline text-text-main-tertiary'
            href={SUNRISE_ACCOUNT_MANAGMENT_AGREEMENT_URL}
            target='_blank'
            id='terms-and-conditions'
            onClick={(e) => {
              e.stopPropagation();
              onTncClick();
            }}
            rel='noreferrer'>
            {t('pages.home.conditions')}
          </a>
        )}
        {!isEmbedded && ', '}
        <a
          className='underline text-text-main-tertiary'
          href={LILI_PRIVACY_POLICY_URL}
          target='_blank'
          id='privacy-policy'
          onClick={(e) => {
            e.stopPropagation();
            onPrivacyPolicyClick();
          }}
          rel='noreferrer'>
          {t('pages.home.privacy')}
        </a>
      </Text.H12>
    </span>
  );
};
